/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function(io) {
  const dialog = document.querySelector('dialog');
  const status = document.getElementById('status');
  const map = document.getElementById('event-map');

  const handleEvent = function(data) {
    if (data.name === 'join' || data.name === 'available') {
      map.classList.add('hidden')
      status.textContent = 'In call queue';
    } else if (data.name === 'answered') {
      map.classList.remove('hidden');
      let html = `<h4>Speaking to ${data.callee.first_name}</h4>`;
      let address
      const callee = data.callee
      if (callee.data.address) {
        address = ['line1', 'town', 'postcode', 'state'].map(field => {
          return callee.data.address[field]
        }).join(' ')
      } else {
        address = `${callee.data.postcode}`
      }
      html += `<p>${callee.phone_number.replace(/^61/, '0')}`
      html += ` | ${address}`
      if (callee.data.nationbuilder_id) {
        const nb_link = `https://gu.nationbuilder.com/admin/signups/${callee.data.nationbuilder_id}`
        html += ` | <a target="_blank" href="${nb_link}">Profile in NationBuilder</a></p>`
      }
      html += '</p>'
      html += `<h5>Upcoming RSVPs:</h5>`
      if (callee.data.upcoming_rsvps) {
        html += callee.data.upcoming_rsvps
                  .split("\n").join('<br/>')
                  .replace(/(\d\..*?)\((https:.*?)\)/g, '<a target="_blank" href="$2">$1<\/a>')
      } else {
        html += '<p>none</p>'
      }
      if (callee.data.postcode || callee.data.nationbuilder_id) {
        const map_url = map.getAttribute('src')
        const member_id = callee.data.nationbuilder_id || ''
        let query_params = `show_online=true&recruiter_id=408465&postcode=${callee.data.postcode}`
        query_params += `&member_id=${member_id}`
        if (!map_url.match(query_params)) {
          const new_map_url = map_url.replace(/(.*?)($|\?).*/, `$1?${query_params}`)
          map.setAttribute('src', new_map_url)
        }
      }
      status.innerHTML = html
    } else if (data.name === 'caller_complete') {
      //status.textContent = 'disconnected';
      alert('Call complete')
      dialog.showModal();
    }
  };

  document.getElementById('submitToken').onsubmit = event => {
    dialog.close();
    event.preventDefault();
    status.classList.remove('hidden');
    status.textContent = 'Connecting..';
    const token = document.getElementById('token').value;
    const socket = io(`https://kooragang-hud-prod-gu.herokuapp.com?token=${token}`);
    //const socket = io(`https://kooragang-hud-prod-gu-stage.herokuapp.com?token=${token}`);

    socket.on('connect', () => {
      status.textContent = 'Connected';
    });
    socket.on('event', handleEvent)

    socket.on('error', function(error) {
      console.error('error: ', error);
      status.textContent = error;
      dialog.showModal();
    });

  };
  window.simulateEvent = data => {
    dialog.close()
    status.classList.remove('hidden');
    map.classList.remove('hidden');
    handleEvent(data)
  }
  window.simulateAnswer = () => {
    const data = {
      name: 'answered',
      callee : {
        first_name: 'Bridger',
        phone_number: '61468519266',
        data : {
          "address": {
              "canonical_address_id": null,
              "country": "AU",
              "created_at": "2018-12-06T09:11:43.919+11:00",
              "id": 415044,
              "line1": "test",
              "line2": null,
              "member_id": null,
              "postcode": "2010",
              "state": "NSW",
              "town": "test",
              "updated_at": "2019-04-13T13:44:23.457+10:00"
          },
          "nationbuilder_id": null,
          "postcode": "2010",
          "upcoming_rsvps": "1. Longman at Longman - Brisbane, QLD, AU at 05:00 on 2100-01-02 (https://action.getup.org.au/longman)\n2. Morayfield East State School at 107 Graham Rd Morayfield, QLD, AU at 05:00 on 2100-01-02 (https://action.getup.org.au/morayfield_east_state_school)"
        }
      }
    }
    window.simulateEvent(data)
  }
  dialog.showModal();

})(window.io);
